import { Action } from '@ngrx/store';

export enum EStepActions {
  SetStep = '[STEP] Set step'
}

export class SetStep implements Action {
  public readonly type = EStepActions.SetStep;
  constructor(public step: number) {}
}

export type StepActions = SetStep;
